import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AppState } from '../AppStore';
import { ProductApi } from '../../api/ProductApi';
import { productCatalogData } from '../Helpers/ProductSettingsSliceHelper';

import type { IAuthorizationRequest, IProductCatalogRequest } from '../../../types/IApiTypes';
import type { IProductPortFolio } from '../../../types/ITypes';

const initialState: IProductPortFolio = {
  productCatalog: {},
  productCatalogDetails: { page: 1, limit: 15, totalRecords: 1 },
  productFilterOptions: { channels: [], business: [] },
  loading: false,
};

//Gets the product model details
export const getInternalProductCatalog = createAsyncThunk(
  'internalProductCatalog/getInternalProductCatalog',
  async (payload: IProductCatalogRequest) => {
    return ProductApi.internalProductCatalog(payload);
  }
);

//Gets product hierarchy
export const getInternalProductFilter = createAsyncThunk(
  'internalProductCatalog/getInternalProductFilter',
  async (payload: IAuthorizationRequest) => {
    return ProductApi.internalProductFilter(payload);
  }
);

const InternalProductCatalogSlice = createSlice({
  name: 'internalProductCatalog',
  initialState: initialState,
  reducers: {
    setInternalProductCatalogDetails(state, action) {
      const { page, limit, totalRecords, channelCodes, agCodes } = action.payload;
      state.productCatalogDetails = { page, limit, totalRecords, channelCodes, agCodes };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInternalProductCatalog.fulfilled, (state, action) => {
        if (action.payload) {
          const data = productCatalogData(action.payload, state);
          state.productCatalog = data.productCatalog;
          state.productCatalogDetails = data.productCatalogDetails;
        }
      })
      .addCase(getInternalProductFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInternalProductFilter.fulfilled, (state, action) => {
        if (action.payload) {
          const { productFilterOptions } = action.payload;
          state.productFilterOptions = productFilterOptions;
          state.loading = false;
        }
      });
  },
});

export const { setInternalProductCatalogDetails } = InternalProductCatalogSlice.actions;

export const internalProductCatalog = (state: AppState) => state.internalProductCatalog;

export default InternalProductCatalogSlice.reducer;
